import React, { useState, useEffect } from "react";
import CustomInput from "components/CustomInput/CustomInput";
import ReactCustomModal from "components/CustomModal/ReactCustomModal";
import UserStrengthModal from "./UserStrengthModal";
import UserService from "services/UserService";
const styles = {
  basicInfoContainer: {
    marginTop: "20px",
  },
  modalActions: {
    justifyContent: "center",
  },
};
export default ({ editable, formik }) => {
  const classes = styles;
  const [openStrength, setOpenStrength] = useState(false);
  const [loading, setLoading] = useState(false);
  const [strengths, setStrengths] = useState([]);
  const [userStrength, setUserStrength] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const response = await UserService.getUserStrength();
        setUserStrength(response.data.data);
        formik.setFieldValue(
          "your_strengths",
          response?.data?.data?.map((item) => item.name).join(",")
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line
  }, []);

  const openModel = async () => {
    setOpenStrength(!openStrength);
    setLoading(true);
    try {
      const response = await UserService.getStrengths();
      setStrengths(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const onCloseModal = () => {
    setOpenStrength(false);
  };
  const setSelectedStrengths = (value) => {
    formik.setFieldValue(
      "your_strengths",
      value?.map((item) => item.name).join(",")
    );
    setUserStrength(value);
  };
  return (
    <>
      <div style={classes.basicInfoContainer} className="row">
        <div className="col-md-12 col-sm-12 col-lg-12">
          <label>Your Strengths</label>
          <CustomInput
            id={"your_strengths"}
            disabled={!editable}
            inputProps={{
              type: "text",
              placeholder: "Your Strengths",
              ...formik.getFieldProps("your_strengths"),
              error: formik.errors.your_strengths,
              onClick: openModel,
            }}
            inputClass="user-profile-inputs-strengths"
            readOnly={true}
          />
        </div>
      </div>
      {openStrength && (
        <>
          <ReactCustomModal
            closeDialog={onCloseModal}
            modelOpen={openStrength}
            headerStyle={{ textAlign: "center" }}
            modalClass="strengthModalClass"
            headerChildren={<h5>{"Select Strengths"}</h5>}
          >
            <UserStrengthModal
              loading={loading}
              strengths={strengths}
              onCloseModal={onCloseModal}
              setSelectedStrengths={setSelectedStrengths}
              userStrength={userStrength}
            />
          </ReactCustomModal>
        </>
      )}
    </>
  );
};
